var map = {
	"./de/mecha-btn.png": "WczX",
	"./en/mecha-btn.png": "17aJ",
	"./es/mecha-btn.png": "qx+v",
	"./fr/mecha-btn.png": "4gxg",
	"./ja/mecha-btn.png": "K2ge",
	"./ko/mecha-btn.png": "69ns",
	"./pt/mecha-btn.png": "/Ryu",
	"./ru/mecha-btn.png": "Y5Ed",
	"./tc/mecha-btn.png": "1YFZ",
	"./th/mecha-btn.png": "HOWi"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "r/CA";